import { render, staticRenderFns } from "./TituloContrato.vue?vue&type=template&id=a4f5b180&"
import script from "./TituloContrato.vue?vue&type=script&lang=js&"
export * from "./TituloContrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports